import PubSub from "pubsub-js";
import { useEffect } from "react";

import type { PubSubActions } from "@/global/pubsub-actions.ts";

export const useSubscription = <T = unknown>(
  event: PubSubActions,
  subscriber: PubSubJS.SubscriptionListener<T>,
  deps: any[] = [],
) => {
  useEffect(() => {
    const token = PubSub.subscribe(event, subscriber);
    return () => {
      PubSub.unsubscribe(token);
    };
  }, deps);
};
